import {useDebugValue} from 'react';

function useDatesSelectors(data) {
    const {
        latestValues: {
            startDate,
            endDate
        }
    } = data;

    /* istanbul ignore next */
    function isValid() {
        return !!startDate && !!endDate;
    }

    const result = {
        isValid
    };

    useDebugValue(result);

    return result;
}

export {useDatesSelectors};
